<template>

  <el-dialog :show-close="true" title="日志文件列表" :visible="dialogVisible" width="85%" @close="bntClick()">
    <!--  表格控件    -->
    <el-table
        :data="fileList"
        style="width: 100%;"
        border
        stripe
    >

      <el-table-column
          fixed
          prop="messageSeq"
          label="消息编号"
          align="center"
          width="150">
      </el-table-column>

      <el-table-column
          prop="deviceCode"
          label="设备编号"
          align="center"
          width="150">
      </el-table-column>

      <el-table-column
          prop="downLoadUrl"
          label="下载链接"
          align="center"
      >
      </el-table-column>


      <el-table-column
          prop="uploadTime"
          label="上传时间"
          align="center"
          :formatter="formatDate"
          width="150">
      </el-table-column>

      <el-table-column
          prop="expiryTime"
          label="过期时间"
          align="center"
          :formatter="formatDate"
          width="150">
      </el-table-column>


      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="110px">
        <template slot-scope="scope">
          <el-button
              @click="downLoad(scope.row)" type="primary" size="small">下载
          </el-button>
          <div style="height: 10px"/>
          <el-button
              @click="downLoadHttps(scope.row)" type="primary" size="small">Https下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="bntClick()">关闭</el-button>
    </div>
  </el-dialog>

</template>

<script>

///通用提示弹框
import dateUtils from "@/utils/dateUtils";
import consoleLog from "@/utils/consoleLog";

export default {
  name: "logFileDialog",
  //完整接收props参数
  props: {
    dialogVisible: {
      type: Boolean,
      default: false //默认值
      // required:true //是必要的
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    downLoad(row) {
      location.href = row.downLoadUrl;
    },
    downLoadHttps(row) {
      try {
        const url = new URL(row.downLoadUrl);
        if (url.protocol === 'http:') {
          url.protocol = 'https:';
        }
        consoleLog.info("downLoadHttps url:", url.toString())
        location.href = url.toString();
      } catch (e) {
        consoleLog.warn("downLoadHttps e:", e)
        // 非法 URL，直接原样跳
        location.href = row.downLoadUrl;
      }
    },
    bntClick() {
      this.$emit('dialogClick')
    },
    formatDate(row, column, cellValue) {
      return dateUtils.timestampToDate(cellValue);
    },
  },

}
</script>

<style scoped>

</style>